import React from 'react'
import { toast } from 'react-toastify'
import AccessTimeIcon from '@mui/icons-material/AccessTime'

import 'react-toastify/dist/ReactToastify.css'
import './styles.scss'

export const showToast = (text, type, duration = 4000, plural = false) => {
  if (type === 'info') {
    return toast.info(text, {
      position: 'top-right',
      autoClose: duration,
      theme: 'dark',
    })
  }

  if (type === 'warning') {
    return toast.warning(text, {
      position: 'top-right',
      autoClose: duration,
      theme: 'dark',
    })
  }

  if (type === 'error') {
    return toast.error(text, {
      position: 'top-right',
      autoClose: duration,
      theme: 'dark',
    })
  }

  if (type === 'success') {
    return toast.success(text, {
      position: 'top-right',
      autoClose: duration,
      theme: 'dark',
    })
  }
  if (type === 'queue') {
    const title = plural ? 'Recordatorios en cola de envío' : 'Recordatorio en cola de envío'
    const body = plural ? 'Se enviarán en los próximos minutos.' : 'Se enviará en los próximos minutos.'
    return toast(
      React.createElement(
        'div',
        null,
        React.createElement('strong', { style: { fontSize: '0.9em', whiteSpace: 'nowrap' } }, title),
        React.createElement('p', { style: { margin: '2px 0 0', fontSize: '0.8em', opacity: 0.85 } }, body),
      ),
      {
        position: 'top-right',
        autoClose: duration,
        theme: 'dark',
        style: { width: '320px' },
        className: 'Toastify__toast--queue',
        icon: () => React.createElement(AccessTimeIcon, { style: { color: '#7c6af7' }, fontSize: 'small' }),
      },
    )
  }
}

export const showToastInternetDisconnected = (customId) => {
  toast.warning('Sin conexión a Internet. Los cambios efectuados ahora no se guardarán', {
    toastId: customId,
    position: 'top-right',
    theme: 'dark',
    autoClose: false,
    closeOnClick: false,
    draggable: false,
    closeButton: false,
    progress: undefined,
  })
}
